import React from 'react';

import { Icon } from '../icons';

export const DotMenuIcon: Icon['component'] = ({ color, style, ...props }) => {
  return (
    <svg {...props} viewBox="0 0 32 32" fill={color} style={style}>
      <g>
        <circle cx="3.2" cy="16.2" r="3.2" />
        <circle cx="16" cy="16.2" r="3.2" />
        <circle cx="28.8" cy="16.2" r="3.2" />
      </g>
    </svg>
  );
};
